export default __webpack_public_path__ + "static/media/stueckgut.47b66edd.jpg";